import React, { FC, useState } from 'react'
import clsx from 'clsx'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { Header } from '../Header'

const drawerWidth = 300

const useStyles = makeStyles((theme: Theme) => ({
  wrap: {
    display: 'flex',
    flexGrow: 1,
    width: '100%',
    height: '100%',
  },
  content: {
    width: '100%',
    flexGrow: 1,
    padding: theme.spacing(5, 4, 4, 34),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
    background: '#292C32',
    height: '100%',
    minHeight: '100vh',
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    overflow: 'auto',
    background: 'transparent !important',
  },
}))

export const GeneralLayout: FC = ({ children }) => {
  const classes = useStyles()
  const [open] = useState<boolean>(true)

  return (
    <div className={classes.wrap}>
      <Header />
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}
      >
        {children}
      </main>
    </div>
  )
}
